import React, { useState } from 'react';
import { signInWithGitHub } from '../lib/auth';

export default function SignInModal({ isOpen, onClose }) {
  const [isSigningIn, setIsSigningIn] = useState(false);
  console.log('[SignInModal] Rendering with isOpen:', isOpen);

  if (!isOpen) return null;

  const handleSignIn = async () => {
    setIsSigningIn(true);
    await signInWithGitHub();
    // Note: user will be redirected, so we don't need to set loading to false
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999999,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '16px',
          maxWidth: '800px',
          width: '100%',
          padding: '48px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.15s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f3f4f6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#6b7280" style={{ width: '20px', height: '20px' }}>
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>

        {/* Header */}
        <h2 style={{
          fontSize: '28px',
          fontWeight: 700,
          color: '#111827',
          margin: '0 0 12px 0',
          textAlign: 'center'
        }}>
          Sign in to unlock
        </h2>

        <p style={{
          fontSize: '15px',
          color: '#6b7280',
          margin: '0 0 40px 0',
          textAlign: 'center'
        }}>
          Connect with GitHub to access these features - they're all free :)
        </p>

        {/* Feature cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          marginBottom: '40px'
        }}>
          {/* Publish Skills */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '24px 20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              background: '#fff',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#f97316" style={{ width: '24px', height: '24px' }}>
                <path d="M15.5 2A1.5 1.5 0 0 0 14 3.5v13a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2h-1ZM9.5 6A1.5 1.5 0 0 0 8 7.5v9A1.5 1.5 0 0 0 9.5 18h1a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 10.5 6h-1ZM3.5 10A1.5 1.5 0 0 0 2 11.5v5A1.5 1.5 0 0 0 3.5 18h1A1.5 1.5 0 0 0 6 16.5v-5A1.5 1.5 0 0 0 4.5 10h-1Z" />
              </svg>
            </div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#111827',
              margin: '0 0 8px 0'
            }}>
              Publish Skills
            </h3>
            <p style={{
              fontSize: '13px',
              color: '#6b7280',
              lineHeight: '1.5',
              margin: 0
            }}>
              Community-driven favorites will drive traffic to your work
              </p>
          </div>

          {/* Favorite Workflows */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '24px 20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              background: '#fff',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#f97316" style={{ width: '24px', height: '24px' }}>
                <path d="m9.653 16.915-.005-.003-.019-.01a20.759 20.759 0 0 1-1.162-.682 22.045 22.045 0 0 1-2.582-1.9C4.045 12.733 2 10.352 2 7.5a4.5 4.5 0 0 1 8-2.828A4.5 4.5 0 0 1 18 7.5c0 2.852-2.044 5.233-3.885 6.82a22.049 22.049 0 0 1-3.744 2.582l-.019.01-.005.003h-.002a.739.739 0 0 1-.69.001l-.002-.001Z" />
              </svg>
            </div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#111827',
              margin: '0 0 8px 0'
            }}>
              Star your Favorite Nodes
            </h3>
            <p style={{
              fontSize: '13px',
              color: '#6b7280',
              lineHeight: '1.5',
              margin: 0
            }}>
              Easily access your favorite community workflows
            </p>
          </div>

          {/* Save Workflows */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '24px 20px',
            textAlign: 'center'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              background: '#fff',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#f97316" style={{ width: '24px', height: '24px' }}>
                <path fillRule="evenodd" d="M10 2c-1.716 0-3.408.106-5.07.31C3.806 2.45 3 3.414 3 4.517V17.25a.75.75 0 0 0 1.075.676L10 15.082l5.925 2.844A.75.75 0 0 0 17 17.25V4.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 2Z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#111827',
              margin: '0 0 8px 0'
            }}>
              Save Workflows
            </h3>
            <p style={{
              fontSize: '13px',
              color: '#6b7280',
              lineHeight: '1.5',
              margin: 0
            }}>
              Sync your workflows across devices and sessions
            </p>
          </div>
        </div>

        {/* Sign in button */}
        <button
          onClick={handleSignIn}
          disabled={isSigningIn}
          style={{
            width: '100%',
            padding: '12px 24px',
            background: '#000',
            border: 'none',
            borderRadius: '8px',
            fontSize: '15px',
            fontWeight: 600,
            color: '#fff',
            cursor: isSigningIn ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            transition: 'all 0.2s ease',
            opacity: isSigningIn ? 0.7 : 1
          }}
          onMouseEnter={(e) => {
            if (!isSigningIn) {
              e.currentTarget.style.background = '#1a1a1a';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSigningIn) {
              e.currentTarget.style.background = '#000';
            }
          }}
        >
          {isSigningIn ? (
            <svg width="20" height="20" viewBox="0 0 20 20" style={{ animation: 'spin 1s linear infinite' }}>
              <circle cx="10" cy="10" r="7.5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeDasharray="25 15" />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '20px', height: '20px' }}>
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
          )}
          {isSigningIn ? 'Signing in...' : 'Sign in with GitHub'}
        </button>
      </div>
    </div>
  );
}
